import type { AuthCookies } from "./auth-cookies";

/** 認証識別子が cookie に無い場合のフォールバック（SpiffArena の既定 IdP 名）。 */
const DEFAULT_AUTHENTICATION_IDENTIFIER = "default";

/**
 * API リクエストに付与する認証ヘッダ。
 *
 * IdP を Zeus IdP に切り替える際に変わるのは実質この関数だけ。
 * access_token が無い（未ログイン）場合は何も付けず、401 を backend に判断させる。
 */
export function buildAuthHeaders(cookies: AuthCookies): Record<string, string> {
  if (cookies.accessToken === null) return {};

  return {
    Authorization: `Bearer ${cookies.accessToken}`,
    "SpiffWorkflow-Authentication-Identifier":
      cookies.authenticationIdentifier ?? DEFAULT_AUTHENTICATION_IDENTIFIER,
  };
}
